<div class="row justify-content-center mt-3 d-flex flex-lg-row-reverse">
    <div class="col-lg-6 col-12 ">
        <div class="row justify-content-center mt-4">
            <div class="col-8 blue_box p-4 text-center">
                <h4 class="heading">Complete Your e-Agreement Signing​</h4>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col-11 white_box p-4">

                <div class="row justify-content-center">
                    <div class="col-11 text-center">
                        <ol class="text-start mt-3 mb-4 content">
                            <li>Make sure your registered email is accessible.​</li>
                            <li>Click <strong>Start e-Agreement Signing</strong> to begin.​</li>
                            <li>You’ll receive an OTP on your registered email.​</li>
                            <li>Enter the OTP to verify your identity.​</li>
                            <li>Review the e-Agreement carefully.​</li>
                            <li>Click <strong>Sign Agreement</strong> to finish.​</li>
                            <li>You’ll be brought back to this page automatically once everything is done.​</li>
                        </ol>

                        <button type="button" class="btn btn-warning px-5" (click)="startEAgreementSign()">
                            Start e-Agreement Signing
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
    <div class="col-lg-5 col-11">
        <app-left-icons></app-left-icons>
    </div>
</div>

<ngx-spinner type="ball-spin-clockwise" size="medium"></ngx-spinner>